import {showToast} from '@/components/Toaster/Toaster';
import appContent from '@/services/content/appContent';

const useReconnectErrorNotification = () => {
    const connectionErrorsContent = appContent.getConnectionErrorsContent();

    // Find content for notification error
    const notificationContent = connectionErrorsContent?.find((x) => x.notificationTitle || x.notificationDescription);

    return () => {
        if (notificationContent) {
            showToast(notificationContent.notificationTitle, {
                description: notificationContent.notificationDescription,
            });
        }
    };
};

export default useReconnectErrorNotification;
